import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import CHICTemplate from './CHICTemplate';
import { CHICParticipants } from '../../../Constants/Data';

const CHIC = () => {
  console.log("CHICParticipants", CHICParticipants);
  const [loading, setLoading] = useState(false);
  const [indexIncrement, setIndexIncrement] = useState(0);
  const [centerSlidePercentage, setCenterSlidePercentage] = useState(33.33);

  useEffect(() => {
    const updateCenterSlidePercentage = () => {
      const width = window.innerWidth;
      if (width < 640) {
        setCenterSlidePercentage(100);
        setIndexIncrement(1);
      } else if (width < 1024) {
        setCenterSlidePercentage(50);
        setIndexIncrement(2);
      } else {
        setCenterSlidePercentage(33.33);
        setIndexIncrement(3);
      }
    };

    updateCenterSlidePercentage();
    window.addEventListener('resize', updateCenterSlidePercentage);

    return () => {
      window.removeEventListener('resize', updateCenterSlidePercentage);
    };
  }, []);


  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + indexIncrement) % CHICParticipants.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - indexIncrement + CHICParticipants.length) % CHICParticipants.length);
  };

  return (
    <div className="w-full flex flex-col pb-10 3xl:pb-16 3xl:py-16 px-[60px] 3xl:px-[120px] relative"
      style={{ backgroundImage: `url(https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/CHIC_BG.jpg)` }}>

      <div className="mt-[36px]">
        <h2 className="font-allroundgothic font-[600] text-[36px] 1.5xl:text-[59px] text-innovationTitle text-center">Innovation Spotlight</h2>
        <p className="mt-6 text-[18px] font-proximanova  text-innovationSubtitle text-center">Meet the participants of the CharmHealth Innovation Challenge</p>
      </div>

      {loading ?
        <div className="flex items-center justify-center mt-24">
          <div className="spinner-border animate-spin inline-block w-8 h-8 border-4 border-t-transparent border-b-transparent border-white rounded-full" role="status" aria-hidden="true">
          </div>
        </div>
        :
        <div className="w-full mt-8 2xl:px-[100px]">
          <button onClick={prevSlide} className="absolute left-[40px] 1.5xl:left-[120px] 3xl:left-[160px] top-1/2 transform -translate-y-1/2">
            <svg className="mr-1" width="22" height="22" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.883618 8.59285C0.883618 8.36756 0.987368 8.14232 1.20966 7.9645L10.1018 0.85064C10.5316 0.506818 11.243 0.506818 11.6728 0.85064C12.1026 1.19446 12.1026 1.76358 11.6728 2.10742L3.56609 8.59277L11.6728 15.0781C12.1026 15.422 12.1026 15.9911 11.6728 16.3349C11.243 16.6787 10.5316 16.6787 10.1018 16.3349L1.20966 9.22105C0.987373 9.04322 0.883618 8.81792 0.883618 8.59269V8.59285Z" fill="#ffa400" />
            </svg>
          </button>
          <div className="1.5xl:px-[80px]">
            <Carousel
              showArrows={false}
              infiniteLoop={false}
              showThumbs={false}
              showStatus={false}
              showIndicators={false}
              selectedItem={currentIndex}
              onChange={(index) => setCurrentIndex(index)}
              centerMode={true}
              centerSlidePercentage={centerSlidePercentage}
            >
              {CHICParticipants.map(participant => (
                <div className="3xl:mt-6 px-[20px] 3xl:px-[40px]">
                  <CHICTemplate name={participant.name} thumbnail={participant.thumbnail} id={participant.id} />
                </div>
              ))}
            </Carousel>
          </div>

          <button onClick={nextSlide} className="absolute right-[40px] 1.5xl:right-[120px] 3xl:right-[160px] top-1/2 transform -translate-y-1/2 z-10">
            <svg className="mr-1" width="22" height="22" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.9953 8.59269C11.9953 8.81799 11.8915 9.04322 11.6693 9.22105L2.77709 16.3349C2.34732 16.6787 1.63592 16.6787 1.20612 16.3349C0.776345 15.9911 0.776345 15.422 1.20612 15.0781L9.31282 8.59277L1.20612 2.10742C0.776345 1.7636 0.776345 1.19448 1.20612 0.85064C1.6359 0.506818 2.3473 0.506818 2.77709 0.85064L11.6693 7.9645C11.8915 8.14233 11.9953 8.36762 11.9953 8.59285V8.59269Z" fill="#ffa400" />
            </svg>
          </button>
        </div>
      }

      <a href="https://charmhealthchallenge.com" className="flex items-center mt-12 3xl:mt-16 w-fit mx-auto no-underline" target="_blank">
        <button className="text-white font-proximanova text-[18px] bg-transparent rounded-full px-16 py-2  border-[1px] w-fit mx-auto">
          Learn more about CHIC
        </button>
      </a>
    </div>
  );
};

export default CHIC;